<template>
  <div class="countdown">
    <span class="text-white font-bold text-6xl">{{ time }}</span>
  </div>
</template>

<script>
export default {
  name: 'Countdown',
  props: {
    time: Number,
  },
};
</script>

<style lang="scss" scoped>
.countdown {
  @apply fixed w-full h-full bg-black bg-opacity-25 flex justify-center items-center top-0 left-0 pb-16;
}
</style>
